export default [

    {
        path: '/dapai',
        name: 'dapai',
        component: () => import('@/views/dapai/dapai'),
        meta: {
            keepAlive: true, //此组件不需要被缓存
            isBack: false,
        }
    },
    {
        path: '/dapaiList',
        name: 'dapaiList',
        component: () => import('@/views/dapai/dapaiList'),
        meta: {
            keepAlive: true, //此组件需要被缓存
            isBack: false,
        }
    },
    {
        path: '/dapai2',
        name: 'dapai2',
        component: () => import('@/views/dapai/dapai2'),
        meta: {
            keepAlive: true, //此组件不需要被缓存
            isBack: false,
        }
    },
    {
        path: '/dapaiXiecai',
        name: 'dapaiXiecai',
        component: () => import('@/views/dapai/dapaiXiecai'),
        meta: {
            keepAlive: true, //此组件不需要被缓存
            isBack: false,
        }
    },
    {
        path: '/xiecaiList',
        name: 'xiecaiList',
        component: () => import('@/views/dapai/xiecaiList'),
        meta: {
            keepAlive: true, //此组件不需要被缓存
            isBack: false,
        }
    },

]



// WEBPACK FOOTER //
// ./src/router/dapai.js